import StyledMutationLink from './StyledMutationLink'

export default StyledMutationLink
